// Does the primary pointer hover?
//
// `(hover: hover)` describes the PRIMARY input device, so a laptop with a
// touchscreen still answers true and keeps every hover affordance; a phone or
// tablet answers false. That is the distinction every caller here wants —
// "can this user hover?" — and it is not the same question as
// `(pointer: coarse)`, which a stylus also answers.
//
// Why it matters beyond taste: on iOS Safari the first tap on an element whose
// hover state changes the page is consumed as a hover and the click is never
// dispatched. Anything hover-only therefore costs a real tap, which is how the
// document row "…" menu came to need two of them — the tooltip on its wrapper
// injected a node on tap one, so tap two was the first tap that opened it.
export function hasHoverPointer(view = window) {
  return view.matchMedia?.("(hover: hover)")?.matches ?? true
}

// The viewport where table popovers become bottom sheets. Mirrors the 768px
// breakpoint the table SCSS uses, so the JS and the stylesheet cannot drift
// into disagreeing about which presentation is on screen.
export const COMPACT_VIEWPORT_QUERY = "(max-width: 768px)"

export function isCompactViewport(view = window) {
  return view.matchMedia?.(COMPACT_VIEWPORT_QUERY)?.matches ?? view.innerWidth <= 768
}
